// Copyright (c) StrangeBee 2024

import React, { ReactElement, ReactNode } from 'react';
import { classList } from '@Helpers/className';
import { Empty, EmptyProps, Spin } from 'antd';

import './DisplayEmptyData.scss';

interface DisplayEmptyDataProps {
    image?: ReactNode;
    imageStyle?: EmptyProps['imageStyle'];
    className?: string;
    label?: ReactNode;
    children?: ReactNode;
    spin?: boolean;
}

export const DisplayEmptyData = ({
    image,
    imageStyle,
    className,
    label,
    children,
    spin,
}: DisplayEmptyDataProps): ReactElement => (
    <Empty
        image={!spin && image}
        imageStyle={imageStyle}
        className={classList('display-empty-data', className)}
        description={
            !spin && (
                <div className="display-empty-data__label">
                    <div className="display-empty-data__label-text">{label}</div> {children}
                </div>
            )
        }
    >
        {spin && <Spin />}
    </Empty>
);
